function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import React from 'react';
import { AmplifyCore } from '@codametrix/ui-common';
import { styleOverrides, styles } from './service-desk.styles';
import { getServiceDeskClient } from '../../clients/service-desk.client';
import { displayJsonInNewWindow } from '../../core/utils/json-view';
const { conditionalUtils } = AmplifyCore;
const classes = styles();
var _React_Component;
class ServiceDesk extends (_React_Component = React.Component) {
    componentDidMount() {
        const onWorkItemSelectHandler = (workitem, worklistContext)=>{
            this.props.openAmplifyCase({
                serviceLine: workitem.service,
                caseId: workitem.cmx_case_uid,
                processId: workitem.cmx_process_id,
                workitemId: workitem.case_id,
                servicedeskMode: true,
                worklistContext,
                isCodingQuality: worklistContext?.isCodingQuality,
                isQualityAssessment: worklistContext?.isQualityAssessment,
                hasAmplifyCaseRunV2Access: this.props.hasAmplifyCaseRunV2Access,
                qaCollectionUuid: workitem.qa_collection_uuid
            });
        };
        const viewWorkitemDataHandler = (workitem)=>{
            displayJsonInNewWindow(workitem);
        };
        const { capabilities } = this.props;
        const widgetOptions = {
            onWorkItemSelected: onWorkItemSelectHandler,
            prodTrackerActive: conditionalUtils.capabilityValue(capabilities?.capabilities.productivityTracker?.on),
            childRef: this.props?.childRef,
            userContext: this.props?.userContext,
            viewWorkitemData: viewWorkitemDataHandler
        };
        const xcaliberClient = getServiceDeskClient();
        xcaliberClient.create(this.props.viewType, 'service_desk', widgetOptions);
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            style: classes.root,
            children: /*#__PURE__*/ _jsx(Box, {
                css: styleOverrides,
                id: "service_desk"
            })
        });
    }
}
_define_property(ServiceDesk, "defaultProps", {
    viewType: 'GRID_WIDGET_WORKLIST_SETTINGS'
});
export { ServiceDesk };
